import React, { useEffect, useState } from "react";
import {
  Box,
  useMediaQuery,
  useTheme,
  SpeedDial,
  SpeedDialIcon,
  SpeedDialAction,
} from "@mui/material";
import AprtmentPlotsOverview from "../components/ApartmentPlots/AprtmentPlotsOverView";
import { useLocation, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import { investorApi } from "../api/api";
import DescriptionIcon from '@mui/icons-material/Description';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import YourApartmentPlotsImages from "../components/YourProperty/YourApartmentPlots/YourApartmentPlotsImages";
import ApartmentDocuments from "../components/ApartmentPlots/ApartmentDocuments";
import YourApartmentPlotDetails from "../components/YourProperty/YourApartmentPlots/YourApartmentPlotDetails";
import YourAprtmentPlotsOverview from "../components/YourProperty/YourApartmentPlots/YourAprtmentPlotsOverview";
import YourApartmentOverviewDetails from "../components/YourProperty/YourApartmentPlots/YourApartmentOverviewDetails";
const YourApartmentPlotsScreen = () => {
  const location = useLocation();
  const property = location.state?.property;
  const theme = useTheme();
  const [searchParams] = useSearchParams();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const SECRET_KEY = "yourSecretKey";
  const encryptedPropertyId = searchParams.get('propertyId');
  const encryptedUserId = searchParams.get('userId');
  const decryptData = (ciphertext) => {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return decryptedData;
    }
    catch (err) {
      return null;
    }
  }
  const aprtmentId = encryptedPropertyId ? decryptData(encryptedPropertyId) : null;
  // const [apartmentData, setApartmentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
 
  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  //   const fetchApartmentDetails = async () => {
  //     try {
  //       if (!property?.id) return;
  //       const response = await investorApi.getApartmentPlotsById(property.id);
  //       if (response.status === 200) {
  //         setApartmentData(response.data);
  //       }
  //     } catch (err) {
  //       console.error("API error:", err);
  //       setError(err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   fetchApartmentDetails();
  // }, [property?.id]);
  const actions = [
    // {
    //   icon: <DescriptionIcon />,
    //   name: "Add Documents",
    //   onClick: () => {
    //     // Do something on clicking document action
    //     // alert("Document action clicked");
    //     navigate("/YourApartmentsPlotsAddDocuments", { state: { property } });
    //   },
    // },
    {
      icon: <AddPhotoAlternateIcon />,
      name: "Add Image",
      onClick: () => {
        // Do something on clicking document action
        // alert("Document action clicked");
        navigate("/YourApartmentPlotAddImages", { state: { property } });
      },
    },
    
    {
      icon: <EditNoteIcon />,
      name: "Edit Details",
      onClick: () => {
        // Do something on clicking document action
        // alert("Document action clicked");
        navigate("/EditApartmentPlotsDetails", { state: { property } });
      },
    },
  ];
  return (
    <>
      <Box sx={{
        width: '100%',
        p: isMobile ? 2 : 4, // Outer padding
        maxWidth: '1800px', // Maximum width for large screens
        margin: '0 auto', // Center the container
      }}>
        <Box sx={{
          width: '100%',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 3 : 2, // Increased gap for better spacing
          marginBottom: "30px"
        }}>
          {/* Images - 60% width */}
          <Box sx={{
            width: isMobile ? '100%' : '100%',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: theme.shadows[2], // Added subtle shadow
            // height: isMobile ? 'auto' : '80vh', // Fixed height on desktop
            minHeight: isMobile ? '300px' : 'none' // Minimum height on mobile
          }}>
            <YourApartmentPlotsImages propertyData={property} />
          </Box>
          {/* Details - 40% width */}
          {/* <Box sx={{
            width: isMobile ? '100%' : '40%',
            borderRadius: 2,
          }}>
            <YourApartmentPlotDetails propertyData={apartmentData} />
          </Box> */}
        </Box>
        <YourAprtmentPlotsOverview data={property} />
          <YourApartmentOverviewDetails data={property} />
        {/* <ApartmentDocuments data={property} /> */}
      </Box>
      <SpeedDial
        ariaLabel="Property actions"
        sx={{
          position: "fixed",
          bottom: {
            xs:65,
            sm:40,
            lg:16
          },
          right: 16,
          zIndex: 1000,
        }}
        icon={<SpeedDialIcon />}
      >
        {actions.map((action) => (
          <SpeedDialAction
            key={action.name}
            icon={action.icon}
            tooltipTitle={action.name}
            onClick={action.onClick}
          />
        ))}
      </SpeedDial>
    </>
  );
};
export default YourApartmentPlotsScreen;